import moment from "moment/moment";

export class Convert {
    static arrayBufferToBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;

        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }

        return window.btoa(binary);
    }

    /**
     * @param {*} date the source date
     * @returns the same source date only considered as a UTC date. Time is ignored and will be trimmed
     */
    static assumeLocalDateAsUTCDate(date) {
        return moment(date).format("yyyy-MM-DD");
    }
}